import { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { PlaceholderState } from 'ui/indexPages/PlaceholderState';

export const Container = styled.div`
  grid-area: body;
  overflow-y: auto;

  &[data-empty='true'] {
    height: auto;
    overflow-y: unset;
  }
`;

export const StyledPlaceholderState = styled(PlaceholderState)`
  min-height: ${pxToRem(300)};
`;

export const ListBody: FC<HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};
